import React, { useState, FC } from "react";
import { Button } from "reactstrap";
import { TableColumnsType } from "antd";
import { Icon, TooltipComponent } from "../../components/Component";
import FormatDate from "../masters/DateFormater";
import { useNavigate } from "react-router";
import InvoiceAside from "./InvoiceAside";
import statusMapper from "./StatusMapper";
import { formatCurrency } from "../../utils/Utils";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";

const ViewInvoiceList: FC = () => {
  const [sm, setSm] = useState(false);
  const navigate = useNavigate();

  const columns: TableColumnsType<any> = [
    {
      title: "Invoice #",
      dataIndex: "invoiceId",
      key: "invoiceId",
      width: 230,
      fixed: "left",
      render(text: any, record: any) {
        return (
          <span
            className="inlineTableCellLink"
            onClick={() => {
              if (
                [
                  "Pending Approval",
                  "Approval Rejected",
                  "To be Dispatched",
                  "Partially Dispatched",
                  "Fully Dispatched",
                ].includes(record.invoiceStatus)
              ) {
                navigate(`/view-invoice/${record.invoiceNumber}`);
              }
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
      render: (date) => <span>{FormatDate(date)}</span>,
      width: 100,
    },
    {
      title: "IRN Status",
      dataIndex: "eInvoiceStatus",
      key: "eInvoiceStatus",
      width: 130,
      render: (text) => {
        let status = text == "N" ? "Not Generated" : "Generated";
        return (
          <>
            <span>{status}</span>
          </>
        );
      },
    },
    // {
    //   title: " Date",
    //   dataIndex: "orderDate",
    //   key: "orderDate",
    //   width: 120,
    //   fixed: "left",
    //   render: (date) => <span>{FormatDate(date)}</span>,
    // },
    {
      title: "Customer",
      dataIndex: "orgName",
      key: "orgName",
      width: 250,
      render: (text: string, record: any, index: any) => {
        return (
          <>
            <span id={`customer-tooltip-${index}`}>
              {text?.length > 20 ? `${text?.substring(0, 25)}... ` : text}
            </span>
            {text?.length > 20 && (
              <TooltipComponent
                iconClass="info-circle text-info"
                icon="info"
                id={`customer-tooltip-${index}`}
                direction="top"
                text={text}
                containerClassName={""}
              />
            )}
          </>
        );
      },
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
    },
    // {
    //   title: "Delivery Date",
    //   dataIndex: "needByDate",
    //   key: "needByDate",
    //   width: 200,
    //   render: (date) => <span>{date ? FormatDate(date) : "N/A"}</span>,
    // },
    {
      title: "Basic Amount",
      dataIndex: "basicAmount",
      key: "basicAmount",
      width: 200,
      render: (text, record) => (
        <div style={{ textAlign: "right" }}>
          <span>{formatCurrency(text, record.currencyCode)}</span>
        </div>
      ),
    },
    {
      title: "SGST",
      dataIndex: "sgst",
      key: "sgst",
      width: 200,
      render: (text, record) => (
        <div style={{ textAlign: "right" }}>
          <span>
            {Number(record?.sgst) && Number(record?.cgst)
              ? formatCurrency(text, record.currencyCode)
              : "N/A"}
          </span>
        </div>
      ),
    },
    {
      title: "CGST",
      dataIndex: "cgst",
      key: "cgst",
      width: 200,
      render: (text, record) => (
        <div style={{ textAlign: "right" }}>
          <span>
            {Number(record?.sgst) && Number(record?.cgst)
              ? formatCurrency(text, record.currencyCode)
              : "N/A"}
          </span>
        </div>
      ),
    },
    {
      title: "IGST",
      dataIndex: "igst",
      key: "igst",
      width: 200,
      render: (text, record) => (
        <div style={{ textAlign: "right" }}>
          <span>
            {!Number(record?.sgst) && !Number(record?.cgst)
              ? formatCurrency(text, record.currencyCode)
              : "N/A"}
          </span>
        </div>
      ),
    },

    {
      title: "Gross Total",
      dataIndex: "grossTotal",
      key: "grossTotal",
      width: 250,
      render: (text, record) => (
        <div style={{ textAlign: "right" }}>
          <span>{formatCurrency(text, record.currencyCode)}</span>
        </div>
      ),
    },
    {
      title: "Created By",
      dataIndex: "createdUserName",
      key: "createdUserName",
      width: 200,
    },
    {
      title: "GRN Status",
      dataIndex: "deliveryStatus",
      key: "deliveryStatus",
      width: 200,
      render(value: any, record: any, index: any) {
        const grnStatus: any = {
          FullyDelivered: "Fully Delivered",
          PartiallyDelivered: "Partially Delivered",
        };
        return <p className="tb-status">{grnStatus[value] || value}</p>;
      },
    },
    {
      title: "Payment Due Date",
      dataIndex: "dueDate",
      key: "dueDate",
      render: (date) => <span>{FormatDate(date)}</span>,
      width: 170,
    },
    {
      title: "Payment Days",
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      width: 150,
      render: (text: any, record: any) => {
        const paymentStatus: any = {
          FullyPaid: "FULLY PAID",
          PartiallyPaid: "PARTIALLY PAID",
        };
        if (text == "Pending") {
          const { days } = record?.due;
          if (days <= 0) {
            return (
              <p
                style={{ color: "blue", fontSize: "14px" }}
                className="tb-status"
              >
                {" "}
                DUE IN {days * -1} DAYS
              </p>
            );
          }
          return (
            <p className="text-danger"> OVERDUE BY {record?.due?.days} DAYS</p>
          );
        }
        return (
          <p style={{ color: "green", fontSize: "14px" }} className="tb-status">
            {paymentStatus[text] || text}
          </p>
        );
      },
    },
    {
      title: "Invoice Status",
      dataIndex: "invoiceStatus",
      key: "invoiceStatus",
      width: 200,
      fixed: "right",
      render: (status: any) => {
        const _status = statusMapper[status]?.seller;
        return (
          <div className="justify-start align-center">
            <h6
              className={`tb-status ms-1`}
              style={{
                color: `${_status?.color}`,
                fontSize: "14px",
              }}
            >
              {_status?.icon} {_status?.title || status}
            </h6>
          </div>
        );
      },
    },
  ];

  return (
    <TransactionFlowDefaultTemplate
      moduleKey="view-invoice-list"
      title="Invoices"
      columns={columns}
      sideNavigation={
        <div
          className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
            sm ? "content-active" : ""
          }`}
        >
          <InvoiceAside updateSm={setSm} sm={sm} />
        </div>
      }
      selectFilters={[
        {
          title: "Invoice Status",
          placeholder: "Select Status",
          options: [
            {
              label: "Pending Approval",
              value: "Pending Approval",
            },
            {
              label: "Partially Dispatched",
              value: "Partially Dispatched",
            },
            {
              label: "Fully Dispatched",
              value: "Fully Dispatched",
            },
            {
              label: "To be Dispatched",
              value: "To be Dispatched",
            },
          ],
        },
        {
          title: "Irn Status",
          placeholder: "Select Irn Status",
          options: [
            {
              label: "Generated",
              value: "Y",
            },
            {
              label: "Not Generated",
              value: "N",
            },
          ],
        },
      ]}
      extra={{
        tableScrollX: 1100,
        dateRange: true,
        excelExport: true,
        dataFilterTootip: "Filtering based on Invoice date",
      }}
    />
  );
};

export default ViewInvoiceList;
